import { registerApi as api } from '../../api';

export const fetchOtherInputsData = async (current_month) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const response = await api.get(`/get_other_inputs/${current_month}`, {
      params: {
        client_id: client_ID
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}
export const updateOtherInputs = async (id, otherInputsData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_other_inputs/${id}`, otherInputsData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}
export const deleteOtherInputs = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_other_inputs/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

// export const otherInputsUpload = async (otherInputsDataInput) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const selectedClientID = sessionStorage.getItem('selectedClient')
//     const response = await api.post('/other_inputs', otherInputsDataInput, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       },
//       params : {
//         'selectedClientID' : selectedClientID
//       }
//     });
//     return {
//       data: response,
//       status: response.status,
//     };
//   } catch (error) {
//     throw error.response.data.error;
//   }
// };

// Make sure your API function is set up correctly
export const otherInputsUpload = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/other_inputs', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params : {
        'selectedClientID' : selectedClientID
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};



export const multiDeleteOtherInputs = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_other_inputs', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
